import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCustomerStatusTableData } from "../../services/services";

export const fetchCustomerStatusTableDataAsync = createAsyncThunk(
  "customerStatusTable/fetchData",
  async (params) => {
    const response = await fetchCustomerStatusTableData(params);
    return response;
  }
);
const initialState = {
  customerStatusTableData: [],
  isLoading: true,
  error: null,
};

const customerStatusTableSlice = createSlice({
  name: "customerStatusTable",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerStatusTableDataAsync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCustomerStatusTableDataAsync.fulfilled, (state, action) => {
        state.customerStatusTableData = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchCustomerStatusTableDataAsync.rejected, (state, action) => {
        state.error = action.error.message;
        state.isLoading = false;
      });
  },
});

export default customerStatusTableSlice.reducer;
